import React, { useState } from "react";

const donateImage = "/Images/DonateHero.jpg";

const Donate = () => {
  const [amount, setAmount] = useState(25);
  const [frequency, setFrequency] = useState("monthly");
  const [selectedUrl, setSelectedUrl] = useState("https://www.birdlife.org.za/support-us/donate/");

  const amounts = [10, 25, 50, 100, 250];

  return (
    <section
      className="container-fluid p-0"
      style={{
        background: "#f5f3ee",
        minHeight: "100vh"
      }}
    >
      <div className="row g-0">

        {/* LEFT SIDE */}

        <div
          className="col-lg-6 text-white position-relative"
          style={{
            minHeight: "100vh",
            backgroundImage: `url(${donateImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}
        >
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              background:
                "linear-gradient(rgba(0,0,0,.15), rgba(0,0,0,.55))"
            }}
          />

          <div
            className="position-relative p-5"
            style={{
              maxWidth: "650px"
            }}
          >
            <h1
              style={{
                fontFamily: "Georgia, serif",
                fontSize: "58px",
                lineHeight: "1.05",
                marginBottom: "30px"
              }}
            >
              Your gift funds real work,
              <br />
              on the ground, right now.
            </h1>

            <p
              style={{
                maxWidth: "500px",
                lineHeight: "1.8",
                marginBottom: "40px"
              }}
            >
              Every contribution is tax-deductible and goes directly
              toward habitat restoration, anti-poaching units,
              and scientific species monitoring.
            </p>

            <ul style={{ paddingLeft: "20px", fontSize: "16px", lineHeight: "1.8" }}>
              <li>BirdLife South Africa</li>
              <li>Mabula Ground Hornbill Project</li>
              <li>SANCCOB</li>
            </ul>


          </div>
        </div>

        {/* RIGHT SIDE */}

        <div
          className="col-lg-6 d-flex align-items-center justify-content-center"
          style={{
            background: "#f5f3ee"
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "520px",
              padding: "50px"
            }}
          >
            <h2
              className="text-center mb-2"
              style={{
                fontFamily: "Georgia, serif",
                fontSize: "60px"
              }}
            >
              Make a Gift
            </h2>

            <p
              className="text-center text-muted mb-5"
              style={{
                fontSize: "14px"
              }}
            >
              Your support changes the trajectory
              for endangered species.
            </p>

            <div className="row mb-4">
              <div className="col-6">
                <button
                  onClick={() => setFrequency("monthly")}
                  className={`btn w-100 ${frequency === "monthly"
                    ? "btn-dark"
                    : "btn-light"
                    }`}
                >
                  Monthly
                </button>
              </div>

              <div className="col-6">
                <button
                  onClick={() => setFrequency("annual")}
                  className={`btn w-100 ${frequency === "annual"
                    ? "btn-dark"
                    : "btn-light"
                    }`}
                >
                  Annual
                </button>
              </div>
            </div>

            <div className="row g-2 mb-4">
              {amounts.map((item) => (
                <div className="col-4" key={item}>
                  <button
                    onClick={() => setAmount(item)}
                    className="btn w-100 rounded-0"
                    style={{
                      height: "60px",
                      background:
                        amount === item
                          ? "#1d2718"
                          : "#fff",
                      color:
                        amount === item
                          ? "#fff"
                          : "#000",
                      border: "1px solid #ddd"
                    }}
                  >
                    ${item}
                  </button>
                </div>
              ))}

              <div className="col-4">
                <button
                  className="btn w-100 rounded-0 border"
                  style={{ height: "60px" }}
                >
                  Other
                </button>
              </div>
            </div>

            <div className="mb-3">
              <label
                className="small text-uppercase mb-2"
                style={{
                  letterSpacing: "2px"
                }}
              >
                Direct Your Gift
              </label>

              <select
                className="form-select rounded-0"
                value={selectedUrl}
                onChange={(e) => setSelectedUrl(e.target.value)}
              >
                <option value="https://www.birdlife.org.za/support-us/donate/">BirdLife South Africa</option>
                <option value="https://www.givengain.com/cause/groundhornbillproject">Mabula Ground Hornbill Project</option>
                <option value="https://donations.sanccob.co.za/">SANCCOB</option>
              </select>
            </div>

            <div className="row mb-3">
              <div className="col-6">
                <input
                  className="form-control rounded-0"
                  placeholder="First Name"
                />
              </div>

              <div className="col-6">
                <input
                  className="form-control rounded-0"
                  placeholder="Last Name"
                />
              </div>
            </div>

            <div className="mb-4">
              <input
                className="form-control rounded-0"
                placeholder="Email Address"
              />
            </div>

            <button
              onClick={() => {
                window.location.href = selectedUrl;
              }}
              className="btn text-white w-100 rounded-0 py-3"
              style={{
                background: "#6b735d",
                letterSpacing: "2px",
                fontWeight: 600
              }}
            >
              DONATE →
            </button>

            <p
              className="text-center text-muted mt-4"
              style={{
                fontSize: "11px",
                lineHeight: "1.8"
              }}
            >
              By clicking donate, you agree to our terms
              of service and acknowledge our privacy policy.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Donate;